import { IAgent } from "store/entities/agents";
import { ITeam } from "store/entities/teams";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function agentTeams(agent: IAgent, teams: ITeam[]) {
  return teams.filter(team => agent.teamIds.includes(team.id));
}
